/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Permission} from './permission.enum';

/* eslint-disable @typescript-eslint/consistent-type-assertions */
export class PermissionEnumMapper {
    private constructor() {
    }

    static fromString(input: string): Permission {
        let userType = Permission.UNKNOWN;

        if (Object.values(Permission)
                .includes(input as Permission)) {

            userType = input as Permission;
        }

        return userType;
    }

    static toString(input: Permission): string {
        return input ?? '';
    }

    static fromStringArray(input: string[]): Permission[] {
        return input?.map(PermissionEnumMapper.fromString);
    }

    static toStringArray(input: Permission[]): string[] {
        return input?.map(PermissionEnumMapper.toString);
    }
}
